import React from "react";
import ReactECharts from "echarts-for-react";

const LineChart = ({ data,title }) => {
  console.log(data)
  const xData = data?.map((item) => item.Day);
  const yData = data?.map((item) => item.Count);

  const options = {
    grid: {
      left: "10%",
      right: "10%",
      top: "10%",
      bottom: "10%",
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#fff",
      borderColor: "#ccc",
      borderWidth: 1,
      borderRadius: 8,
      padding: [10, 15],
      textStyle: {
        color: "#333",
        fontSize: 14,
      },
      formatter: (params) => {
        // Filter out data points that are null, undefined, or "None"
        const validParams = params.filter(
          (item) => item.data !== null && item.data !== undefined && item.data !== "None"
        );
        if (validParams.length === 0) return ""; // Return empty string to hide tooltip
        return validParams
          .map(
            (item) =>
              `${item.axisValue}: ${item.data}<br />` // Use `axisValue` for the x-axis label
          )
          .join("");
      },
    },
    
    xAxis: {
      type: "category",
      data: xData,
      boundaryGap: false,
      axisLabel: {
        fontSize: 10,
        color: "#333",
      },
      axisTick: {
        showMinLabel: true, // Always show the first label
        showMaxLabel: true, // Always show the last label
        interval: 0, // Show all labels; adjust as needed based on space
        show: true, // Show major ticks
        alignWithLabel: true, // Align major ticks with labels
      },
      minorTick: {
        show: true, // Show minor ticks
        splitNumber: 4, // Number of minor ticks between two major ticks
      },
    
     
    }, 
    yAxis: {
      type: "value",
      boundaryGap: [0, 0.1],
      axisLabel: {
        fontSize: 12,
        color: "#333",
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#E0E0E0",
        },
      },
    },
    // dataZoom: [
    //   {
    //     type: "slider",
    //     xAxisIndex: 0,
    //     start: 0,
    //     end: 50, // Show the first 100% initially
    //     bottom: "10px", // Move the slider up to avoid overlapping
    //     handleSize: "100%", // Make the handle larger for better UX
    //     handleStyle: {
    //       color: "#85D7FF", // Light blue handle color
    //       borderWidth: 1,
    //       borderColor: "#5AB1F6", // Slightly darker blue border
    //     },
    //     fillerColor: "rgba(133, 215, 255, 0.2)", // Transparent light blue background
    //     borderColor: "transparent", // Remove the border for a cleaner look
    //     textStyle: {
    //       color: "transparent", // Hide text
    //     },
    //   },
    // ],



    series: [
      {
        data: yData,
        type: "line",
        connectNulls: false,
        smooth: true,
        lineStyle: {
          width: 2,
          color: "#85D7FF",
        },
        itemStyle: {
          color: "#85D7FF",
        },
        symbol: "circle",
        symbolSize: 4,
      },
    ],
  };

  return (
    <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "20px" }}>
      <h3 style={{ fontSize: "16px", color: "#333", marginBottom: "10px" }}>
        {title}
      </h3>
      <ReactECharts option={options} style={{ height: "400px", width: "100%" }} />
    </div>
  );
};

export default LineChart;
